package com.cybersoftsolution.cybersoftsolutionweb.components.imageUploader

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.MyButton
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.MyButtonType
import com.cybersoftsolution.cybersoftsolutionweb.components.textfield.InputTypeHTML
import com.cybersoftsolution.cybersoftsolutionweb.components.textfield.MyTextField
import com.cybersoftsolution.cybersoftsolutionweb.pages.admin.Device.isDesktop
import com.cybersoftsolution.cybersoftsolutionweb.styles.CreateStyle
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.imagenFieldNameId
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.upploadButtonId
import com.varabyte.kobweb.browser.file.loadDataUrlFromDisk
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import kotlinx.browser.document
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.w3c.dom.HTMLInputElement

@Composable
fun ImageUploader(
    data:String,
    modifier: Modifier = Modifier
        .fillMaxWidth(if (isDesktop()) {70.percent} else {100.percent})
        .height(70.px)
        .margin(bottom = 12.px),
    inputDisabled: Boolean,
    onImageSelected: (data:String) -> Unit,
    forceClear: Boolean = false,
){

    val empty=""
    var fileName by remember{ mutableStateOf(empty) }
    var uri by remember{ mutableStateOf(empty) }
    var url by remember{ mutableStateOf(empty) }

    if (data.contains("http")){
        url = data
    }
    if (data.contains("base64")){
        uri = data
//        fileName = "Imagen seleccionada"
    }




    LaunchedEffect(forceClear) {
        if (forceClear) {
            (document.getElementById(imagenFieldNameId) as HTMLInputElement).value = empty
            fileName = empty
            uri = empty
            url = empty
            onImageSelected(empty)
        }
    }



    LaunchedEffect(inputDisabled) {
        if (!inputDisabled) {
            onImageSelected(uri)
        } else {
            onImageSelected(url)
        }

    }


    Box (
        contentAlignment = Alignment.CenterEnd,
        modifier = modifier

    ) {
        MyTextField(
            enabled = inputDisabled,
            modifier = Modifier
                .fillMaxWidth()
                .padding(left = 24.px,right = 200.px) // 170.px)
                .height(54.px)
                .fontSize(14.px),
            text = if (!inputDisabled) fileName else url ,
            style = CreateStyle,
            inputTypeHTML = InputTypeHTML.Text,
            id = imagenFieldNameId,
            placeholder = if (!inputDisabled) {
                if (fileName.isEmpty() && uri.isEmpty()){
                    "Seleccionar Imagen"

                } else {
                    "Imagen seleccionada"
                }

            } else "Establecer URL de la Imagen",
            onChange = { text ->
                    url = text
                    onImageSelected(url)
            }
        )
        Box(
            contentAlignment = Alignment.CenterEnd,
            modifier = Modifier.padding(leftRight = 8.px)
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically
            ) {
                if (uri.isNotEmpty()) {
                    MyButton(
                        buttonType = MyButtonType.Secondary,
                        enabled = !inputDisabled,
                        id = "deleteButton",
                        text = "X",
                        modifier = Modifier
                            .padding(leftRight = 8.px)
                            .margin(leftRight = 4.px)
                            .borderRadius(25.px)
                            .height(38.px)
                            .width(38.px),
                        onClick = {
                            fileName = ""
                            uri = ""
                            onImageSelected(uri)
                        }

                    )
                }

                MyButton(
                    enabled = !inputDisabled,
                    modifier = Modifier
                        .padding(leftRight = 8.px)

                        .borderRadius(25.px)
                        .height(38.px),
                    id = upploadButtonId,
                    text = if (uri.isEmpty()) "Subir Imagen" else "Remplazar",
                    onClick = {
                        document.clear()
                        document.loadDataUrlFromDisk(
                            accept = "image/*",
                            onError = {},
                            onLoad = {
                                uri = it
                                fileName = filename
                                onImageSelected(uri)
                            }
                        )
                    }
                )
            }

        }

    }
}